/**
 * sprungziel.js — das Merkmal, an dem der Fokusring eines Sprungs haengt.
 *
 * @description
 *   `data-sprungziel="aktiv"` ist der Hausname fuer „hierher wurde gesprungen";
 *   zwei Stellen setzen es ueber React-Zustand (`VendorAnschriften.jsx`,
 *   `SituationHeader.jsx`). Zwei weitere koennen das nicht: `springeZu` in
 *   `pages/invoicing/Betrieb.jsx` steht als Modulfunktion ausserhalb des Baums,
 *   und der Abschnitt dort ist zustandslos; `zuRefunds` in
 *   `pages/invoicing/InvoiceList.jsx` setzt den Fokus auf ein Paneel, das keine
 *   eigene Komponente mit Zustand ist. Beide brauchen dieselben zwei Zeilen —
 *   sie stehen deshalb hier einmal statt zweimal daneben.
 *
 *   🔴 Der Rueckweg ist ein NATIVER `blur`-Listener mit `{ once: true }`, kein
 *   `onBlur`: die Aufrufer haben keinen Zustand, an dem ein Prop haengen
 *   koennte. Sachlicher Nebeneffekt — ein nativer `blur` blubbert nicht, Reacts
 *   `onBlur` ist `focusout` und tut es (die Hausstellen sichern sich dagegen mit
 *   `e.target === e.currentTarget` ab; hier ist die Wache ueberfluessig).
 *
 *   🔴 „Einmalig" heisst EINMAL JE LISTENER, nicht ein Listener insgesamt: ein
 *   Sprung auf ein bereits fokussiertes Ziel feuert kein `blur`-Ereignis, der
 *   vorige Listener bleibt also stehen, und erst der naechste echte
 *   Fokusverlust raeumt alle ab. Das ist unschaedlich — jeder entfernt dasselbe
 *   Attribut, und `removeAttribute` auf ein fehlendes Attribut ist ein No-op.
 *   Begrenzt ist die Zahl durch die Klicks auf dasselbe, schon fokussierte Ziel.
 *
 *   🔴 Das Attribut ist fuer Reacts Render unsichtbar: es gehoert keiner Prop.
 *   Ein Re-Render des Zielknotens laesst es stehen, ein Re-MOUNT (neuer Knoten)
 *   verliert es still — der Ring erscheint dann nicht, der Fokus ist davon
 *   unberuehrt.
 */

/**
 * Setzt das Sprung-Merkmal am Ziel und nimmt es beim naechsten Fokusverlust zurueck.
 *
 * @param {Element|null|undefined} ziel Der Knoten, an dem der Ring haengen soll.
 */
export function markiereSprungziel(ziel) {
  if (!ziel) return;
  ziel.setAttribute('data-sprungziel', 'aktiv');
  ziel.addEventListener('blur', () => ziel.removeAttribute('data-sprungziel'), { once: true });
}
